export const enum ProjectUserRoles {
	ROLE_GUEST = 'ROLE_GUEST',
	ROLE_ADMIN = 'ROLE_ADMIN',
	ROLE_CLIENT = 'ROLE_CLIENT',
	ROLE_AUDITOR = 'ROLE_AUDITOR',
	ROLE_EMPLOYEE = 'ROLE_EMPLOYEE',
}